import * as CONSTANTS from "./constants";

/**
 * Determine if content is advertiser sponsored, based on sponsor meta data
 * @param {Object} sponsorMeta Object containing sponsor meta (specifically, sponsor label)
 * @returns {Boolean} True iff advertiser sponsored
 */

// CBC content sponsored by an Advertiser ("Template #3")
export function isAdvertiserSponsored(sponsorMeta) {
    // CBC content sponsored by an Advertiser (PRFD-4441)
    return (
        sponsorMeta &&
        sponsorMeta.label &&
        !isCoCreatedContent(sponsorMeta.label) &&
        !isAdvertorial(sponsorMeta.label)
    );
}

// Co-created content ("Template #2")
export function isCoCreatedContent(sponsorLabel) {
    return sponsorLabel === CONSTANTS.CO_CREATED_CONTENT;
}

// Client Branded Content ("Template #1")
export function isAdvertorial(sponsorLabel) {
    return sponsorLabel === CONSTANTS.ADVERTORIAL;
}

export function getSponsorLabel(sponsorLabel) {
    switch (sponsorLabel) {
        case CONSTANTS.CO_CREATED_CONTENT:
            return `${CONSTANTS.SPONSOR_LABEL} with`;
        default:
            return sponsorLabel;
    }
}
